import { Radio } from '@ksyos/design-system';
import type { OsasRequestAdditionalExaminationData } from '@common/validation/customControls/osas/osasAdditionalExaminationSchema';
import { getOsasSleepRecorderText } from '@common/utils/getOsasSleepRecorderTypeText';
import { SleepRecorderType } from '@common/validation/customControls/osas/sleepRecorderType';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { RadioGroupFormGroup, TextAreaFormGroup } from '../../processActivityFormGroupFields';

export function OsasRequestAdditionalExaminationEdit(): JSX.Element {
    const { onChange } = useProcessActivityEditContext<OsasRequestAdditionalExaminationData>();
    const translate = getSelectedLanguage();

    return (
        <>
            <RadioGroupFormGroup
                fieldKey="sleepRecorderType"
                isRequired={true}
                label="Selecteer het type slaaprecorder"
                onChange={async (value) => {
                    onChange(
                        {
                            sleepRecorderType: value as SleepRecorderType,
                        },
                        'sleepRecorderType'
                    );
                }}
            >
                <Radio
                    key={SleepRecorderType.recorderWithSmartphone}
                    label={getOsasSleepRecorderText(SleepRecorderType.recorderWithSmartphone)}
                    value={SleepRecorderType.recorderWithSmartphone}
                />
                <Radio
                    key={SleepRecorderType.recorderWithoutSmartphone}
                    label={getOsasSleepRecorderText(SleepRecorderType.recorderWithoutSmartphone)}
                    value={SleepRecorderType.recorderWithoutSmartphone}
                />
            </RadioGroupFormGroup>

            <TextAreaFormGroup
                fieldKey="reasonChanged"
                isRequired={true}
                label={translate.osas.reasonChanged}
            />
        </>
    );
}
